import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import useFlashMessage from './useFlashMessage';
import { activateUser, getCurrentUser, loginUser, logoutUser } from '../api/user/AuthApi';
import { useRouter } from 'vue-router';

// ログインユーザー
const currentUser = ref();

export function useAuthUser() {
  const router = useRouter();
  const { t } = useI18n();

  /**
   * 本登録
   *
   * @param token
   * @param password
   * @returns {Promise<void>}
   */
  async function activate(token, password) {
    const { showFlashMessage } = useFlashMessage();

    currentUser.value = await activateUser(token, password);
    showFlashMessage('success', t('auth.activate_success'));

    await router.push({ name: 'my.profile' });
  }

  /**
   * ログイン処理
   *
   * @param email
   * @param password
   * @param remember
   * @returns {Promise<void>}
   */
  async function login(email, password, remember) {
    currentUser.value = await loginUser(email, password, remember);
    await router.push({ name: 'my.profile' });
  }

  /**
   * ログアウト処理
   *
   * @returns {Promise<void>}
   */
  async function logout() {
    const { showFlashMessage } = useFlashMessage();

    try {
      await logoutUser();
    } catch (err) {
      return;
    }

    currentUser.value = null;
    showFlashMessage('success', t('auth.logout_success'));

    await router.push({ name: 'login' });
  }

  /**
   * ログイン中のユーザーを取得
   *
   * @returns {Promise<any>}
   */
  async function fetchCurrentUser() {
    currentUser.value = await getCurrentUser();
  }

  return {
    login,
    logout,
    activate,
    currentUser,
    fetchCurrentUser,
  };
}
